var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#2563EB",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8709 8.29913C19.0568 8.49072 19.1613 8.75054 19.1613 9.02145C19.1613 9.29236 19.0568 9.55218 18.8709 9.74377L11.6805 17.1509C11.4945 17.3424 11.2423 17.45 10.9793 17.45C10.7163 17.45 10.4641 17.3424 10.2781 17.1509L7.30278 14.0859C7.20805 13.9916 7.1325 13.8789 7.08052 13.7542C7.02854 13.6296 7.00118 13.4955 7.00004 13.3599C6.99889 13.2242 7.02399 13.0897 7.07385 12.9641C7.12372 12.8386 7.19736 12.7245 7.29048 12.6286C7.38361 12.5326 7.49434 12.4568 7.61623 12.4054C7.73811 12.354 7.86871 12.3282 8.0004 12.3294C8.13208 12.3305 8.26222 12.3587 8.38322 12.4123C8.50423 12.4658 8.61366 12.5436 8.70515 12.6412L10.9793 14.9839L17.4685 8.29913C17.6545 8.1076 17.9067 8 18.1697 8C18.4327 8 18.6849 8.1076 18.8709 8.29913Z",
    fill: "#033EE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlay);
export default __webpack_public_path__ + "static/media/Overlay.851a26043664740b5907cd3a6bfe3a14.svg";
export { ForwardRef as ReactComponent };